import { useState, useEffect } from 'react';
import { GetRequest } from 'components/common';

const useDrawingMaterials = (widgetIdentifier, drawingId, onMaterialChange) => {
  const [materials, setMaterials] = useState([]);
  const [selectedMaterialId, setSelectedMaterialId] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMaterials = () => {
    if (!drawingId) {
      return;
    }
    setLoading(true);
    GetRequest({
      url: `/widget/quote-builder/${widgetIdentifier}/materials?drawing_id=${drawingId}`,
      callback: (data) => {
        setMaterials(data.materials || []);
        if (data.materials && data.materials.length > 0) {
          setSelectedMaterialId(data.materials[0].id);
        }
        setLoading(false);
      },
      errorCallback: () => {
        setLoading(false);
      }
    });
  };

  const handleChange = (event) => {
    const newMaterialId = event.target.value;
    setSelectedMaterialId(newMaterialId);
    if (onMaterialChange) {
      onMaterialChange(newMaterialId);
    }
  };

  useEffect(fetchMaterials, [widgetIdentifier, drawingId]);

  return {
    materials,
    selectedMaterialId,
    loading,
    handleChange,
    shouldRender: !loading && materials.length > 0
  };
};

export default useDrawingMaterials;
